/* eslint-disable react/prop-types */
import Link from 'next/link'
import dynamic from 'next/dynamic'
import Column from '../../layout/Column'
import Columns from '../../layout/Columns'
import styles from './styles.module.scss'
import HouseDetails from '../../custom/HouseDetails'
import ArrowPrev from '/public/icons/icon-screenshots-prev.svg'
import ArrowNext from '/public/icons/icon-screenshots-next.svg'
import SlickSlider from '../../elements/SlickSlider'
import { withModifiers } from '../../helpers/withModifiers'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import startCase from 'lodash-es/startCase'
import capitalize from 'lodash-es/capitalize'
import isEmpty from 'lodash-es/isEmpty'
import Button from '../../elements/Button'
import { getS3Url } from '../../helpers/getS3Url'
import { withComma } from '../../helpers/withComma'
import { useModalContext } from '/providers/modalProvider'
import { CSSTransition } from 'react-transition-group'
const InquiryModal = dynamic(() => import('/components/custom/InquiryModal'))
import {
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  EmailShareButton
} from 'react-share'
import FacebookIcon from '/public/icons/icon-facebook.svg'
import PinterestIcon from '/public/icons/icon-pinterest.svg'
import LinkedinIcon from '/public/icons/icon-linkedin.svg'
import EmailIcon from '/public/icons/icon-email.svg'
import IconCheck from '/public/icons/icon-checkbox-check.svg'
import IconHeart from '/public/icons/icon-favourite.svg'
import IconShare from '/public/icons/icon-share.svg'
import IconCopy from '/public/icons/icon-copy.svg'
import Dropdown from '../../elements/Dropdown'
import { useCurrencyContext } from '/providers/currencyProvider'

import { useState } from 'react'
import { useRouter } from 'next/router'
import { useFavouritesContext } from '/providers/favouritesProvider'
import LazyImage from '../../elements/LazyImage'

const EstateCard = ({
  price_upon_request,
  title,
  neighbourhood,
  property_type,
  price,
  variant = [],
  cardRef,
  cloudflare_gallery,
  setHovered,
  propertyTitle,
  id,
  is_exclusive,
  interior,
  exterior,
  bedroom_no,
  bathroom_no,
  land_size,
  short_description,
  slug,
  translations,
  card_label
}) => {
  const { setContent, handleShowModal, setVariant } = useModalContext()
  const [copied, setCopied] = useState(false)
  const url = `/real-estate/${slug}`
  const router = useRouter()
  // eslint-disable-next-line no-undef
  const shareUrl = `${process.env.NEXT_PUBLIC_DOMAIN_URL}${url}`
  const isSimple = variant.includes('simple')
  const { selectedCurrency } = useCurrencyContext()
  const { addOrRemoveFavourite, isFavourite } = useFavouritesContext()

  return (
    <div
      onMouseEnter={() => setHovered && setHovered(id)}
      onMouseLeave={() => setHovered && setHovered(false)}
      ref={cardRef}
      className={withModifiers('card', variant, styles)}
    >
      {cloudflare_gallery && cloudflare_gallery?.length !== 0 && (
        <Link href={url}>
          <a>
            <SlickSlider
              nextArrow={<ArrowNext />}
              prevArrow={<ArrowPrev />}
              slidesToShow={1}
              pagination={true}
              className={styles.card__slider}
            >
              {cloudflare_gallery.slice(0, 7).map((item, index) => (
                <div key={index} className={styles.card__image}>
                  <LazyImage
                    sizes="(min-width: 1250px) 588px, (max-width: 1250px) 640px, (max-width: 400px) 400px,
            50vw"
                    src={getS3Url(item, '640')}
                    width={540}
                    height={360}
                    index
                  />
                </div>
              ))}
            </SlickSlider>
          </a>
        </Link>
      )}

      <div className={styles.card__type}>
        {card_label
          ? card_label
          : is_exclusive
          ? translations.card.exclusive[router.locale]
          : property_type}
      </div>

      <div className={styles.card__content}>
        <Link href={url}>
          <a className={styles.card__header}>
            <div className={styles.card__intro}>
              {neighbourhood && (
                <span className={styles.card__location}>
                  {neighbourhood?.replace(/-/g, ' ')}
                </span>
              )}

              {(propertyTitle || title) && (
                <h2 className={styles.card__title}>
                  {title
                    ? title.replace(/\w+/g, capitalize).replace(/-/g, ' ')
                    : propertyTitle}
                </h2>
              )}
            </div>
          </a>
        </Link>

        <Columns
          variant={['-align-center', '-distribute-between', 'no-gutter']}
        >
          <Column variant={['no-padding', 'align-middle']}>
            <HouseDetails
              variant={['close']}
              bedrooms={bedroom_no && bedroom_no !== 0 ? bedroom_no : undefined}
              bathrooms={
                bathroom_no && bathroom_no !== 0 ? bathroom_no : undefined
              }
            />
          </Column>

          <Column variant={['no-padding']}>
            <div className={styles.card__buttons}>
              <Button
                onClick={() => addOrRemoveFavourite(id)}
                className={withModifiers(
                  'card__heart',
                  [isFavourite(id) && 'is-active'],
                  styles
                )}
                name="Favourite"
                appendIcon={<IconHeart width={17} />}
                arrow={false}
                variant={['label', 'close', 'blue']}
              ></Button>

              {!isSimple && (
                <Dropdown
                  variant={['socials']}
                  buttonVariant={['close', 'blue']}
                  appendIcon={<IconShare />}
                  arrow={false}
                >
                  <div className={styles.card__socials}>
                    <FacebookShareButton url={shareUrl}>
                      <div
                        className={withModifiers(
                          'card__link',
                          ['facebook'],
                          styles
                        )}
                      >
                        <FacebookIcon width={16} height={16} />
                      </div>
                    </FacebookShareButton>
                    <LinkedinShareButton url={shareUrl}>
                      <div
                        className={withModifiers(
                          'card__link',
                          ['linkedin'],
                          styles
                        )}
                      >
                        <LinkedinIcon width={16} height={16} />
                      </div>
                    </LinkedinShareButton>
                    <PinterestShareButton url={shareUrl}>
                      <div
                        className={withModifiers(
                          'card__link',
                          ['pinterest'],
                          styles
                        )}
                      >
                        <PinterestIcon width={17} height={28} />
                      </div>
                    </PinterestShareButton>
                    <EmailShareButton
                      url={shareUrl}
                      subject={translations.card.shareWith[router.locale]}
                    >
                      <div className={styles.card__link}>
                        <EmailIcon width={16} height={16} />
                      </div>
                    </EmailShareButton>

                    <CopyToClipboard
                      text={shareUrl}
                      onCopy={() => {
                        setCopied(true)
                        setTimeout(() => setCopied(false), 5000)
                      }}
                    >
                      <div className={styles.card__link}>
                        {!copied ? (
                          <CSSTransition
                            classNames="opacity"
                            appear={true}
                            timeout={{ enter: 200, exit: 200 }}
                            key={copied ? 'fire' : 'static'}
                          >
                            <IconCopy width={16} height={16} />
                          </CSSTransition>
                        ) : (
                          <CSSTransition
                            classNames="opacity"
                            appear={true}
                            timeout={{ enter: 200, exit: 200 }}
                            key={copied}
                          >
                            <IconCheck width={15} height={13} />
                          </CSSTransition>
                        )}
                      </div>
                    </CopyToClipboard>
                  </div>
                </Dropdown>
              )}
            </div>
          </Column>
        </Columns>

        {!isSimple && (
          <div className={styles.card__details}>
            {short_description && (
              <p className={styles.card__description}>{short_description}</p>
            )}

            {interior && !isEmpty(interior) && (
              <div className={styles.card__row}>
                <span>{translations.card.interior[router.locale]}</span>

                <span>
                  {withComma(interior?.size)} {startCase(interior?.measure)}
                </span>
              </div>
            )}

            {exterior && !isEmpty(exterior) && (
              <div className={styles.card__row}>
                <span>{translations.card.exterior[router.locale]}</span>

                <span>
                  {withComma(exterior?.size)} {startCase(exterior?.measure)}
                </span>
              </div>
            )}

            {land_size && !isEmpty(land_size) && (
              <div className={styles.card__row}>
                <span>{translations.card.landsize[router.locale]}</span>

                <span>
                  {withComma(land_size?.size)} {startCase(land_size?.measure)}
                </span>
              </div>
            )}

            {price && (
              <div className={styles.card__row}>
                <span>{translations.card.price[router.locale]}</span>

                <span
                  className={
                    price_upon_request
                      ? styles.card__fontDefault
                      : styles.card__fontPrimary
                  }
                >
                  {price_upon_request
                    ? translations.card.onRequest[router.locale]
                    : `${selectedCurrency.coin}${
                        price[selectedCurrency.value]
                      }`}
                </span>
              </div>
            )}

            <Button
              onClick={() => {
                setVariant(['contained'])
                setContent(
                  <InquiryModal
                    form={{
                      title: propertyTitle || title
                    }}
                    translations={translations}
                    name={propertyTitle || title}
                  />
                )
                handleShowModal()
              }}
              name={translations.card.inquire[router.locale]}
              arrow={false}
              variant={['color-primary', 'blue']}
            >
              {translations.card.inquire[router.locale]}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default EstateCard
